<template>
  <loading v-if="loadingStatus" />
  <div v-else>
    <template
      v-for="section in sections"
    >
      <div
        v-if="section.type === 'ASSESSORIA_CIENTIFICA' || section.type === 'EXECUTIVO_VENDAS'"
        :key="section.label"
        class="contact-section"
      >
        <h3>{{ section.label }}</h3>
        <template v-if="section.contacts.length">
          <div
            v-for="(contact, index) in section.contacts"
            :key="index"
            class="general-data__content-wrapper"
          >
            <div class="contact-section__box-inputs">
              <input
                v-model="contact.name"
                type="text"
                placeholder="Nome"
                disabled
              >
            </div>
            <div class="contact-section__box-inputs">
              <input
                v-model="contact.email"
                type="email"
                placeholder="E-mail"
                disabled
              >
              <input
                v-model="contact.phone"
                v-mask="'(##) #####-####'"
                type="tel"
                placeholder="Telefone"
                disabled
              >
            </div>
          </div>
        </template>
        <template v-else>
          Nenhum contato foi encontrado
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import generalDataService from '@/api/generalData'
import notify from '@/api/notification'

export default {
  data() {
    return {
      loadingStatus: false,
      sections: [
        { label: 'Nova Amostra', contacts: [], type: 'NOVA_AMOSTRA' },
        { label: 'Laboratório', contacts: [], type: 'LAB' },
        { label: 'Comercial', contacts: [], type: 'COMERCIAL' },
        { label: 'Técnico', contacts: [], type: 'TECNICO' },
        { label: 'Financeiro', contacts: [], type: 'FINANCEIRO' },
        { label: 'Gestor', contacts: [], type: 'GESTOR' },
        { label: 'Nps', contacts: [], type: 'NPS' },
        { label: 'Assessoria Científica', contacts: [], type: 'ASSESSORIA_CIENTIFICA' },
        { label: 'Executivo de Vendas', contacts: [], type: 'EXECUTIVO_VENDAS' }
      ],
      contactTypes: {
        1: 'COMERCIAL',
        2: 'TECNICO',
        3: 'FINANCEIRO',
        4: 'GESTOR',
        5: 'NOVA_AMOSTRA',
        6: 'LAB',
        8: 'NPS',
        9: 'ASSESSORIA_CIENTIFICA',
        10: 'EXECUTIVO_VENDAS'
      }
    }
  },
  computed: {
    ...mapGetters(['profile', 'toggle'])
  },
  mounted() {
    this.getContacts()
  },
  methods: {
    processContacts(contacts) {
      this.sections.forEach(section => {
        section.contacts = []
      })
      contacts.forEach(contact => {
        const contactTypeId = contact.contactType.id
        const contactTypeLabel = this.contactTypes[contactTypeId]
        const section = this.sections.find(sec => sec.type === contactTypeLabel)
        if (section) {
          section.contacts.push({
            id: contact.id,
            name: contact.name,
            email: contact.email,
            phone: contact.phone,
            contactType: contactTypeLabel,
            laborId: contact.laborId ? contact.laborId : this.profile.id_laboratory
          })
        }
      })
    },
    getContacts() {
      this.loadingStatus = true
      generalDataService
        .getContacts()
        .then(res => {
          this.processContacts(res.data)
          this.loadingStatus = false
        })
        .catch(err => {
          this.loadingStatus = false
          console.error('Erro ao buscar contatos:', err)
        })
    }
  },
}
</script>